import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=5902d484&scoped=true"
import script from "./ServiceInfo.vue?vue&type=script&lang=js"
export * from "./ServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./ServiceInfo.vue?vue&type=style&index=0&id=5902d484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5902d484",
  null
  
)

export default component.exports